/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AccessToken,
  Courier,
  CourierPackage,
  CourierSettings,
  CourierUser,
  Invoice,
  MailOption,
  Mailbox,
  NewCourierPackage,
  NewCourierUser,
  NewInvoice,
  NewMailbox,
  NewRewardTransaction,
  NewRewardsAccount,
  NewRole,
  NewRoleMapping,
  RewardTransaction,
  RewardsAccount,
  Role,
  RoleMapping,
  RoleMappingCount200Response,
  RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest,
  RoleMappingExistsGetRoleMappingsIdExists200Response,
  RoleMappingUpdateAll200Response,
} from '../models/index';
import {
    AccessTokenFromJSON,
    AccessTokenToJSON,
    CourierFromJSON,
    CourierToJSON,
    CourierPackageFromJSON,
    CourierPackageToJSON,
    CourierSettingsFromJSON,
    CourierSettingsToJSON,
    CourierUserFromJSON,
    CourierUserToJSON,
    InvoiceFromJSON,
    InvoiceToJSON,
    MailOptionFromJSON,
    MailOptionToJSON,
    MailboxFromJSON,
    MailboxToJSON,
    NewCourierPackageFromJSON,
    NewCourierPackageToJSON,
    NewCourierUserFromJSON,
    NewCourierUserToJSON,
    NewInvoiceFromJSON,
    NewInvoiceToJSON,
    NewMailboxFromJSON,
    NewMailboxToJSON,
    NewRewardTransactionFromJSON,
    NewRewardTransactionToJSON,
    NewRewardsAccountFromJSON,
    NewRewardsAccountToJSON,
    NewRoleFromJSON,
    NewRoleToJSON,
    NewRoleMappingFromJSON,
    NewRoleMappingToJSON,
    RewardTransactionFromJSON,
    RewardTransactionToJSON,
    RewardsAccountFromJSON,
    RewardsAccountToJSON,
    RoleFromJSON,
    RoleToJSON,
    RoleMappingFromJSON,
    RoleMappingToJSON,
    RoleMappingCount200ResponseFromJSON,
    RoleMappingCount200ResponseToJSON,
    RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequestFromJSON,
    RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequestToJSON,
    RoleMappingExistsGetRoleMappingsIdExists200ResponseFromJSON,
    RoleMappingExistsGetRoleMappingsIdExists200ResponseToJSON,
    RoleMappingUpdateAll200ResponseFromJSON,
    RoleMappingUpdateAll200ResponseToJSON,
} from '../models/index';

export interface RewardTransactionCountRequest {
    where?: string;
}

export interface RewardTransactionCreateRequest {
    data?: NewRewardTransaction;
}

export interface RewardTransactionCreateChangeStreamGetRewardTransactionsChangeStreamRequest {
    options?: string;
}

export interface RewardTransactionCreateChangeStreamPostRewardTransactionsChangeStreamRequest {
    roleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest?: RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest;
}

export interface RewardTransactionDeleteByIdRequest {
    id: string;
}

export interface RewardTransactionExistsGetRewardTransactionsidExistsRequest {
    id: string;
}

export interface RewardTransactionExistsHeadRewardTransactionsidRequest {
    id: string;
}

export interface RewardTransactionFindRequest {
    filter?: string;
}

export interface RewardTransactionFindByIdRequest {
    id: string;
    filter?: string;
}

export interface RewardTransactionFindOneRequest {
    filter?: string;
}

export interface RewardTransactionPatchOrCreateRequest {
    data?: RewardTransaction;
}

export interface RewardTransactionPrototypeCountCourierRewardsAccountsRequest {
    id: string;
    where?: string;
}

export interface RewardTransactionPrototypeCountCourierUserAccessTokensRequest {
    id: string;
    where?: string;
}

export interface RewardTransactionPrototypeCountCourierUserCourierPackagesRequest {
    id: string;
    where?: string;
}

export interface RewardTransactionPrototypeCountCourierUserInvoicesRequest {
    id: string;
    where?: string;
}

export interface RewardTransactionPrototypeCountCourierUserMailboxesRequest {
    id: string;
    where?: string;
}

export interface RewardTransactionPrototypeCountCourierUserReferrerRequest {
    id: string;
    where?: string;
}

export interface RewardTransactionPrototypeCountCourierUserRoleMappingsRequest {
    id: string;
    where?: string;
}

export interface RewardTransactionPrototypeCountCourierUserRolesRequest {
    id: string;
    where?: string;
}

export interface RewardTransactionPrototypeCreateCourierCourierSettingRequest {
    id: string;
    data?: CourierSettings;
}

export interface RewardTransactionPrototypeCreateCourierMailOptionRequest {
    id: string;
    data?: MailOption;
}

export interface RewardTransactionPrototypeCreateCourierPackageInvoiceRequest {
    id: string;
    data?: Invoice;
}

export interface RewardTransactionPrototypeCreateCourierRewardsAccountsRequest {
    id: string;
    data?: NewRewardsAccount;
}

export interface RewardTransactionPrototypeCreateCourierUserAccessTokensRequest {
    id: string;
    data?: AccessToken;
}

export interface RewardTransactionPrototypeCreateCourierUserCourierPackagesRequest {
    id: string;
    data?: NewCourierPackage;
}

export interface RewardTransactionPrototypeCreateCourierUserInvoicesRequest {
    id: string;
    data?: NewInvoice;
}

export interface RewardTransactionPrototypeCreateCourierUserMailboxesRequest {
    id: string;
    data?: NewMailbox;
}

export interface RewardTransactionPrototypeCreateCourierUserReferrerRequest {
    id: string;
    data?: NewCourierUser;
}

export interface RewardTransactionPrototypeCreateCourierUserRewardsAccountRequest {
    id: string;
    data?: RewardsAccount;
}

export interface RewardTransactionPrototypeCreateCourierUserRoleMappingsRequest {
    id: string;
    data?: NewRoleMapping;
}

export interface RewardTransactionPrototypeCreateCourierUserRolesRequest {
    id: string;
    data?: NewRole;
}

export interface RewardTransactionPrototypeDeleteCourierRewardsAccountsRequest {
    id: string;
}

export interface RewardTransactionPrototypeDeleteCourierUserAccessTokensRequest {
    id: string;
}

export interface RewardTransactionPrototypeDeleteCourierUserCourierPackagesRequest {
    id: string;
}

export interface RewardTransactionPrototypeDeleteCourierUserInvoicesRequest {
    id: string;
}

export interface RewardTransactionPrototypeDeleteCourierUserMailboxesRequest {
    id: string;
}

export interface RewardTransactionPrototypeDeleteCourierUserReferrerRequest {
    id: string;
}

export interface RewardTransactionPrototypeDeleteCourierUserRoleMappingsRequest {
    id: string;
}

export interface RewardTransactionPrototypeDeleteCourierUserRolesRequest {
    id: string;
}

export interface RewardTransactionPrototypeDestroyByIdCourierRewardsAccountsRequest {
    id: string;
    fk: string;
}

export interface RewardTransactionPrototypeDestroyByIdCourierUserAccessTokensRequest {
    id: string;
    fk: string;
}

export interface RewardTransactionPrototypeDestroyByIdCourierUserCourierPackagesRequest {
    id: string;
    fk: string;
}

export interface RewardTransactionPrototypeDestroyByIdCourierUserInvoicesRequest {
    id: string;
    fk: string;
}

export interface RewardTransactionPrototypeDestroyByIdCourierUserMailboxesRequest {
    id: string;
    fk: string;
}

export interface RewardTransactionPrototypeDestroyByIdCourierUserReferrerRequest {
    id: string;
    fk: string;
}

export interface RewardTransactionPrototypeDestroyByIdCourierUserRoleMappingsRequest {
    id: string;
    fk: string;
}

export interface RewardTransactionPrototypeDestroyByIdCourierUserRolesRequest {
    id: string;
    fk: string;
}

export interface RewardTransactionPrototypeDestroyCourierCourierSettingRequest {
    id: string;
}

export interface RewardTransactionPrototypeDestroyCourierMailOptionRequest {
    id: string;
}

export interface RewardTransactionPrototypeDestroyCourierPackageInvoiceRequest {
    id: string;
}

export interface RewardTransactionPrototypeDestroyCourierUserRewardsAccountRequest {
    id: string;
}

export interface RewardTransactionPrototypeExistsCourierUserRolesRequest {
    id: string;
    fk: string;
}

export interface RewardTransactionPrototypeFindByIdCourierRewardsAccountsRequest {
    id: string;
    fk: string;
}

export interface RewardTransactionPrototypeFindByIdCourierUserAccessTokensRequest {
    id: string;
    fk: string;
}

export interface RewardTransactionPrototypeFindByIdCourierUserCourierPackagesRequest {
    id: string;
    fk: string;
}

export interface RewardTransactionPrototypeFindByIdCourierUserInvoicesRequest {
    id: string;
    fk: string;
}

export interface RewardTransactionPrototypeFindByIdCourierUserMailboxesRequest {
    id: string;
    fk: string;
}

export interface RewardTransactionPrototypeFindByIdCourierUserReferrerRequest {
    id: string;
    fk: string;
}

export interface RewardTransactionPrototypeFindByIdCourierUserRoleMappingsRequest {
    id: string;
    fk: string;
}

export interface RewardTransactionPrototypeFindByIdCourierUserRolesRequest {
    id: string;
    fk: string;
}

export interface RewardTransactionPrototypeGetCourierRequest {
    id: string;
    refresh?: boolean;
}

export interface RewardTransactionPrototypeGetCourierCourierSettingRequest {
    id: string;
    refresh?: boolean;
}

export interface RewardTransactionPrototypeGetCourierMailOptionRequest {
    id: string;
    refresh?: boolean;
}

export interface RewardTransactionPrototypeGetCourierPackageRequest {
    id: string;
    refresh?: boolean;
}

export interface RewardTransactionPrototypeGetCourierPackageCourierRequest {
    id: string;
    refresh?: boolean;
}

export interface RewardTransactionPrototypeGetCourierPackageInvoiceRequest {
    id: string;
    refresh?: boolean;
}

export interface RewardTransactionPrototypeGetCourierPackageOwnerRequest {
    id: string;
    refresh?: boolean;
}

export interface RewardTransactionPrototypeGetCourierRewardsAccountsRequest {
    id: string;
    filter?: string;
}

export interface RewardTransactionPrototypeGetCourierUserRequest {
    id: string;
    refresh?: boolean;
}

export interface RewardTransactionPrototypeGetCourierUserAccessTokensRequest {
    id: string;
    filter?: string;
}

export interface RewardTransactionPrototypeGetCourierUserCourierPackagesRequest {
    id: string;
    filter?: string;
}

export interface RewardTransactionPrototypeGetCourierUserInvoicesRequest {
    id: string;
    filter?: string;
}

export interface RewardTransactionPrototypeGetCourierUserMailboxesRequest {
    id: string;
    filter?: string;
}

export interface RewardTransactionPrototypeGetCourierUserReferrerRequest {
    id: string;
    filter?: string;
}

export interface RewardTransactionPrototypeGetCourierUserRewardsAccountRequest {
    id: string;
    refresh?: boolean;
}

export interface RewardTransactionPrototypeGetCourierUserRoleMappingsRequest {
    id: string;
    filter?: string;
}

export interface RewardTransactionPrototypeGetCourierUserRolesRequest {
    id: string;
    filter?: string;
}

export interface RewardTransactionPrototypeLinkCourierUserRolesRequest {
    id: string;
    fk: string;
    data?: RoleMapping;
}

export interface RewardTransactionPrototypePatchAttributesRequest {
    id: string;
    data?: RewardTransaction;
}

export interface RewardTransactionPrototypeUnlinkCourierUserRolesRequest {
    id: string;
    fk: string;
}

export interface RewardTransactionPrototypeUpdateByIdCourierRewardsAccountsRequest {
    id: string;
    fk: string;
    data?: RewardsAccount;
}

export interface RewardTransactionPrototypeUpdateByIdCourierUserAccessTokensRequest {
    id: string;
    fk: string;
    data?: AccessToken;
}

export interface RewardTransactionPrototypeUpdateByIdCourierUserCourierPackagesRequest {
    id: string;
    fk: string;
    data?: CourierPackage;
}

export interface RewardTransactionPrototypeUpdateByIdCourierUserInvoicesRequest {
    id: string;
    fk: string;
    data?: Invoice;
}

export interface RewardTransactionPrototypeUpdateByIdCourierUserMailboxesRequest {
    id: string;
    fk: string;
    data?: Mailbox;
}

export interface RewardTransactionPrototypeUpdateByIdCourierUserReferrerRequest {
    id: string;
    fk: string;
    data?: CourierUser;
}

export interface RewardTransactionPrototypeUpdateByIdCourierUserRoleMappingsRequest {
    id: string;
    fk: string;
    data?: RoleMapping;
}

export interface RewardTransactionPrototypeUpdateByIdCourierUserRolesRequest {
    id: string;
    fk: string;
    data?: Role;
}

export interface RewardTransactionPrototypeUpdateCourierCourierSettingRequest {
    id: string;
    data?: CourierSettings;
}

export interface RewardTransactionPrototypeUpdateCourierMailOptionRequest {
    id: string;
    data?: MailOption;
}

export interface RewardTransactionPrototypeUpdateCourierPackageInvoiceRequest {
    id: string;
    data?: Invoice;
}

export interface RewardTransactionPrototypeUpdateCourierUserRewardsAccountRequest {
    id: string;
    data?: RewardsAccount;
}

export interface RewardTransactionReplaceByIdPostRewardTransactionsidReplaceRequest {
    id: string;
    data?: RewardTransaction;
}

export interface RewardTransactionReplaceByIdPutRewardTransactionsidRequest {
    id: string;
    data?: RewardTransaction;
}

export interface RewardTransactionReplaceOrCreatePostRewardTransactionsReplaceOrCreateRequest {
    data?: RewardTransaction;
}

export interface RewardTransactionReplaceOrCreatePutRewardTransactionsRequest {
    data?: RewardTransaction;
}

export interface RewardTransactionUpdateAllRequest {
    where?: string;
    data?: RewardTransaction;
}

export interface RewardTransactionUpsertWithWhereRequest {
    where?: string;
    data?: RewardTransaction;
}

/**
 * 
 */
export class RewardTransactionApi extends runtime.BaseAPI {

    /**
     * Count instances of the model matched by where from the data source.
     */
    async rewardTransactionCountRaw(requestParameters: RewardTransactionCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardTransactions/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingCount200ResponseFromJSON(jsonValue));
    }

    /**
     * Count instances of the model matched by where from the data source.
     */
    async rewardTransactionCount(requestParameters: RewardTransactionCountRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingCount200Response> {
        const response = await this.rewardTransactionCountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new instance of the model and persist it into the data source.
     */
    async rewardTransactionCreateRaw(requestParameters: RewardTransactionCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RewardTransaction>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/RewardTransactions`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewRewardTransactionToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RewardTransactionFromJSON(jsonValue));
    }

    /**
     * Create a new instance of the model and persist it into the data source.
     */
    async rewardTransactionCreate(requestParameters: RewardTransactionCreateRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RewardTransaction> {
        const response = await this.rewardTransactionCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a change stream.
     */
    async rewardTransactionCreateChangeStreamGetRewardTransactionsChangeStreamRaw(requestParameters: RewardTransactionCreateChangeStreamGetRewardTransactionsChangeStreamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: any = {};

        if (requestParameters['options'] != null) {
            queryParameters['options'] = requestParameters['options'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardTransactions/change-stream`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Create a change stream.
     */
    async rewardTransactionCreateChangeStreamGetRewardTransactionsChangeStream(requestParameters: RewardTransactionCreateChangeStreamGetRewardTransactionsChangeStreamRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.rewardTransactionCreateChangeStreamGetRewardTransactionsChangeStreamRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a change stream.
     */
    async rewardTransactionCreateChangeStreamPostRewardTransactionsChangeStreamRaw(requestParameters: RewardTransactionCreateChangeStreamPostRewardTransactionsChangeStreamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/RewardTransactions/change-stream`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequestToJSON(requestParameters['roleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest']),
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Create a change stream.
     */
    async rewardTransactionCreateChangeStreamPostRewardTransactionsChangeStream(requestParameters: RewardTransactionCreateChangeStreamPostRewardTransactionsChangeStreamRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.rewardTransactionCreateChangeStreamPostRewardTransactionsChangeStreamRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a model instance by {{id}} from the data source.
     */
    async rewardTransactionDeleteByIdRaw(requestParameters: RewardTransactionDeleteByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionDeleteById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardTransactions/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Delete a model instance by {{id}} from the data source.
     */
    async rewardTransactionDeleteById(requestParameters: RewardTransactionDeleteByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.rewardTransactionDeleteByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Check whether a model instance exists in the data source.
     */
    async rewardTransactionExistsGetRewardTransactionsidExistsRaw(requestParameters: RewardTransactionExistsGetRewardTransactionsidExistsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingExistsGetRoleMappingsIdExists200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionExistsGetRewardTransactionsidExists().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardTransactions/{id}/exists`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingExistsGetRoleMappingsIdExists200ResponseFromJSON(jsonValue));
    }

    /**
     * Check whether a model instance exists in the data source.
     */
    async rewardTransactionExistsGetRewardTransactionsidExists(requestParameters: RewardTransactionExistsGetRewardTransactionsidExistsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingExistsGetRoleMappingsIdExists200Response> {
        const response = await this.rewardTransactionExistsGetRewardTransactionsidExistsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Check whether a model instance exists in the data source.
     */
    async rewardTransactionExistsHeadRewardTransactionsidRaw(requestParameters: RewardTransactionExistsHeadRewardTransactionsidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingExistsGetRoleMappingsIdExists200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionExistsHeadRewardTransactionsid().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardTransactions/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'HEAD',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingExistsGetRoleMappingsIdExists200ResponseFromJSON(jsonValue));
    }

    /**
     * Check whether a model instance exists in the data source.
     */
    async rewardTransactionExistsHeadRewardTransactionsid(requestParameters: RewardTransactionExistsHeadRewardTransactionsidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingExistsGetRoleMappingsIdExists200Response> {
        const response = await this.rewardTransactionExistsHeadRewardTransactionsidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find all instances of the model matched by filter from the data source.
     */
    async rewardTransactionFindRaw(requestParameters: RewardTransactionFindRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<RewardTransaction>>> {
        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardTransactions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(RewardTransactionFromJSON));
    }

    /**
     * Find all instances of the model matched by filter from the data source.
     */
    async rewardTransactionFind(requestParameters: RewardTransactionFindRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<RewardTransaction>> {
        const response = await this.rewardTransactionFindRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find a model instance by {{id}} from the data source.
     */
    async rewardTransactionFindByIdRaw(requestParameters: RewardTransactionFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RewardTransaction>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionFindById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardTransactions/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RewardTransactionFromJSON(jsonValue));
    }

    /**
     * Find a model instance by {{id}} from the data source.
     */
    async rewardTransactionFindById(requestParameters: RewardTransactionFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RewardTransaction> {
        const response = await this.rewardTransactionFindByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find first instance of the model matched by filter from the data source.
     */
    async rewardTransactionFindOneRaw(requestParameters: RewardTransactionFindOneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RewardTransaction>> {
        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardTransactions/findOne`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RewardTransactionFromJSON(jsonValue));
    }

    /**
     * Find first instance of the model matched by filter from the data source.
     */
    async rewardTransactionFindOne(requestParameters: RewardTransactionFindOneRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RewardTransaction> {
        const response = await this.rewardTransactionFindOneRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Patch an existing model instance or insert a new one into the data source.
     */
    async rewardTransactionPatchOrCreateRaw(requestParameters: RewardTransactionPatchOrCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RewardTransaction>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/RewardTransactions`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: RewardTransactionToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RewardTransactionFromJSON(jsonValue));
    }

    /**
     * Patch an existing model instance or insert a new one into the data source.
     */
    async rewardTransactionPatchOrCreate(requestParameters: RewardTransactionPatchOrCreateRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RewardTransaction> {
        const response = await this.rewardTransactionPatchOrCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Counts rewardsAccounts of Courier.
     */
    async rewardTransactionPrototypeCountCourierRewardsAccountsRaw(requestParameters: RewardTransactionPrototypeCountCourierRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeCountCourierRewardsAccounts().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardTransactions/{id}/courier/rewardsAccounts/count`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingCount200ResponseFromJSON(jsonValue));
    }

    /**
     * Counts rewardsAccounts of Courier.
     */
    async rewardTransactionPrototypeCountCourierRewardsAccounts(requestParameters: RewardTransactionPrototypeCountCourierRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingCount200Response> {
        const response = await this.rewardTransactionPrototypeCountCourierRewardsAccountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Counts accessTokens of CourierUser.
     */
    async rewardTransactionPrototypeCountCourierUserAccessTokensRaw(requestParameters: RewardTransactionPrototypeCountCourierUserAccessTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeCountCourierUserAccessTokens().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardTransactions/{id}/courierUser/accessTokens/count`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingCount200ResponseFromJSON(jsonValue));
    }

    /**
     * Counts accessTokens of CourierUser.
     */
    async rewardTransactionPrototypeCountCourierUserAccessTokens(requestParameters: RewardTransactionPrototypeCountCourierUserAccessTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingCount200Response> {
        const response = await this.rewardTransactionPrototypeCountCourierUserAccessTokensRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Counts courierPackages of CourierUser.
     */
    async rewardTransactionPrototypeCountCourierUserCourierPackagesRaw(requestParameters: RewardTransactionPrototypeCountCourierUserCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeCountCourierUserCourierPackages().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardTransactions/{id}/courierUser/courierPackages/count`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingCount200ResponseFromJSON(jsonValue));
    }

    /**
     * Counts courierPackages of CourierUser.
     */
    async rewardTransactionPrototypeCountCourierUserCourierPackages(requestParameters: RewardTransactionPrototypeCountCourierUserCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingCount200Response> {
        const response = await this.rewardTransactionPrototypeCountCourierUserCourierPackagesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Counts invoices of CourierUser.
     */
    async rewardTransactionPrototypeCountCourierUserInvoicesRaw(requestParameters: RewardTransactionPrototypeCountCourierUserInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeCountCourierUserInvoices().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardTransactions/{id}/courierUser/invoices/count`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingCount200ResponseFromJSON(jsonValue));
    }

    /**
     * Counts invoices of CourierUser.
     */
    async rewardTransactionPrototypeCountCourierUserInvoices(requestParameters: RewardTransactionPrototypeCountCourierUserInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingCount200Response> {
        const response = await this.rewardTransactionPrototypeCountCourierUserInvoicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Counts mailboxes of CourierUser.
     */
    async rewardTransactionPrototypeCountCourierUserMailboxesRaw(requestParameters: RewardTransactionPrototypeCountCourierUserMailboxesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeCountCourierUserMailboxes().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardTransactions/{id}/courierUser/mailboxes/count`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingCount200ResponseFromJSON(jsonValue));
    }

    /**
     * Counts mailboxes of CourierUser.
     */
    async rewardTransactionPrototypeCountCourierUserMailboxes(requestParameters: RewardTransactionPrototypeCountCourierUserMailboxesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingCount200Response> {
        const response = await this.rewardTransactionPrototypeCountCourierUserMailboxesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Counts referrer of CourierUser.
     */
    async rewardTransactionPrototypeCountCourierUserReferrerRaw(requestParameters: RewardTransactionPrototypeCountCourierUserReferrerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeCountCourierUserReferrer().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardTransactions/{id}/courierUser/referrer/count`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingCount200ResponseFromJSON(jsonValue));
    }

    /**
     * Counts referrer of CourierUser.
     */
    async rewardTransactionPrototypeCountCourierUserReferrer(requestParameters: RewardTransactionPrototypeCountCourierUserReferrerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingCount200Response> {
        const response = await this.rewardTransactionPrototypeCountCourierUserReferrerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Counts roleMappings of CourierUser.
     */
    async rewardTransactionPrototypeCountCourierUserRoleMappingsRaw(requestParameters: RewardTransactionPrototypeCountCourierUserRoleMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeCountCourierUserRoleMappings().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardTransactions/{id}/courierUser/roleMappings/count`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingCount200ResponseFromJSON(jsonValue));
    }

    /**
     * Counts roleMappings of CourierUser.
     */
    async rewardTransactionPrototypeCountCourierUserRoleMappings(requestParameters: RewardTransactionPrototypeCountCourierUserRoleMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingCount200Response> {
        const response = await this.rewardTransactionPrototypeCountCourierUserRoleMappingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Counts roles of CourierUser.
     */
    async rewardTransactionPrototypeCountCourierUserRolesRaw(requestParameters: RewardTransactionPrototypeCountCourierUserRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeCountCourierUserRoles().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardTransactions/{id}/courierUser/roles/count`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingCount200ResponseFromJSON(jsonValue));
    }

    /**
     * Counts roles of CourierUser.
     */
    async rewardTransactionPrototypeCountCourierUserRoles(requestParameters: RewardTransactionPrototypeCountCourierUserRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingCount200Response> {
        const response = await this.rewardTransactionPrototypeCountCourierUserRolesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in courierSetting of this model.
     */
    async rewardTransactionPrototypeCreateCourierCourierSettingRaw(requestParameters: RewardTransactionPrototypeCreateCourierCourierSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierSettings>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeCreateCourierCourierSetting().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/RewardTransactions/{id}/courier/courierSetting`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CourierSettingsToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierSettingsFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in courierSetting of this model.
     */
    async rewardTransactionPrototypeCreateCourierCourierSetting(requestParameters: RewardTransactionPrototypeCreateCourierCourierSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierSettings> {
        const response = await this.rewardTransactionPrototypeCreateCourierCourierSettingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in mailOption of this model.
     */
    async rewardTransactionPrototypeCreateCourierMailOptionRaw(requestParameters: RewardTransactionPrototypeCreateCourierMailOptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MailOption>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeCreateCourierMailOption().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/RewardTransactions/{id}/courier/mailOption`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MailOptionToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MailOptionFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in mailOption of this model.
     */
    async rewardTransactionPrototypeCreateCourierMailOption(requestParameters: RewardTransactionPrototypeCreateCourierMailOptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MailOption> {
        const response = await this.rewardTransactionPrototypeCreateCourierMailOptionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in invoice of this model.
     */
    async rewardTransactionPrototypeCreateCourierPackageInvoiceRaw(requestParameters: RewardTransactionPrototypeCreateCourierPackageInvoiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Invoice>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeCreateCourierPackageInvoice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/RewardTransactions/{id}/courierPackage/invoice`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InvoiceToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvoiceFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in invoice of this model.
     */
    async rewardTransactionPrototypeCreateCourierPackageInvoice(requestParameters: RewardTransactionPrototypeCreateCourierPackageInvoiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Invoice> {
        const response = await this.rewardTransactionPrototypeCreateCourierPackageInvoiceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in rewardsAccounts of this model.
     */
    async rewardTransactionPrototypeCreateCourierRewardsAccountsRaw(requestParameters: RewardTransactionPrototypeCreateCourierRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RewardsAccount>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeCreateCourierRewardsAccounts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/RewardTransactions/{id}/courier/rewardsAccounts`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewRewardsAccountToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RewardsAccountFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in rewardsAccounts of this model.
     */
    async rewardTransactionPrototypeCreateCourierRewardsAccounts(requestParameters: RewardTransactionPrototypeCreateCourierRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RewardsAccount> {
        const response = await this.rewardTransactionPrototypeCreateCourierRewardsAccountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in accessTokens of this model.
     */
    async rewardTransactionPrototypeCreateCourierUserAccessTokensRaw(requestParameters: RewardTransactionPrototypeCreateCourierUserAccessTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AccessToken>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeCreateCourierUserAccessTokens().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/RewardTransactions/{id}/courierUser/accessTokens`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AccessTokenToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AccessTokenFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in accessTokens of this model.
     */
    async rewardTransactionPrototypeCreateCourierUserAccessTokens(requestParameters: RewardTransactionPrototypeCreateCourierUserAccessTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AccessToken> {
        const response = await this.rewardTransactionPrototypeCreateCourierUserAccessTokensRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in courierPackages of this model.
     */
    async rewardTransactionPrototypeCreateCourierUserCourierPackagesRaw(requestParameters: RewardTransactionPrototypeCreateCourierUserCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierPackage>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeCreateCourierUserCourierPackages().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/RewardTransactions/{id}/courierUser/courierPackages`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewCourierPackageToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierPackageFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in courierPackages of this model.
     */
    async rewardTransactionPrototypeCreateCourierUserCourierPackages(requestParameters: RewardTransactionPrototypeCreateCourierUserCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierPackage> {
        const response = await this.rewardTransactionPrototypeCreateCourierUserCourierPackagesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in invoices of this model.
     */
    async rewardTransactionPrototypeCreateCourierUserInvoicesRaw(requestParameters: RewardTransactionPrototypeCreateCourierUserInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Invoice>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeCreateCourierUserInvoices().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/RewardTransactions/{id}/courierUser/invoices`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewInvoiceToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvoiceFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in invoices of this model.
     */
    async rewardTransactionPrototypeCreateCourierUserInvoices(requestParameters: RewardTransactionPrototypeCreateCourierUserInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Invoice> {
        const response = await this.rewardTransactionPrototypeCreateCourierUserInvoicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in mailboxes of this model.
     */
    async rewardTransactionPrototypeCreateCourierUserMailboxesRaw(requestParameters: RewardTransactionPrototypeCreateCourierUserMailboxesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Mailbox>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeCreateCourierUserMailboxes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/RewardTransactions/{id}/courierUser/mailboxes`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewMailboxToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MailboxFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in mailboxes of this model.
     */
    async rewardTransactionPrototypeCreateCourierUserMailboxes(requestParameters: RewardTransactionPrototypeCreateCourierUserMailboxesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Mailbox> {
        const response = await this.rewardTransactionPrototypeCreateCourierUserMailboxesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in referrer of this model.
     */
    async rewardTransactionPrototypeCreateCourierUserReferrerRaw(requestParameters: RewardTransactionPrototypeCreateCourierUserReferrerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierUser>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeCreateCourierUserReferrer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/RewardTransactions/{id}/courierUser/referrer`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewCourierUserToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierUserFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in referrer of this model.
     */
    async rewardTransactionPrototypeCreateCourierUserReferrer(requestParameters: RewardTransactionPrototypeCreateCourierUserReferrerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierUser> {
        const response = await this.rewardTransactionPrototypeCreateCourierUserReferrerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in rewardsAccount of this model.
     */
    async rewardTransactionPrototypeCreateCourierUserRewardsAccountRaw(requestParameters: RewardTransactionPrototypeCreateCourierUserRewardsAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RewardsAccount>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeCreateCourierUserRewardsAccount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/RewardTransactions/{id}/courierUser/rewardsAccount`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RewardsAccountToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RewardsAccountFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in rewardsAccount of this model.
     */
    async rewardTransactionPrototypeCreateCourierUserRewardsAccount(requestParameters: RewardTransactionPrototypeCreateCourierUserRewardsAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RewardsAccount> {
        const response = await this.rewardTransactionPrototypeCreateCourierUserRewardsAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in roleMappings of this model.
     */
    async rewardTransactionPrototypeCreateCourierUserRoleMappingsRaw(requestParameters: RewardTransactionPrototypeCreateCourierUserRoleMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMapping>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeCreateCourierUserRoleMappings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/RewardTransactions/{id}/courierUser/roleMappings`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewRoleMappingToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in roleMappings of this model.
     */
    async rewardTransactionPrototypeCreateCourierUserRoleMappings(requestParameters: RewardTransactionPrototypeCreateCourierUserRoleMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMapping> {
        const response = await this.rewardTransactionPrototypeCreateCourierUserRoleMappingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance in roles of this model.
     */
    async rewardTransactionPrototypeCreateCourierUserRolesRaw(requestParameters: RewardTransactionPrototypeCreateCourierUserRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Role>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeCreateCourierUserRoles().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/RewardTransactions/{id}/courierUser/roles`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewRoleToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleFromJSON(jsonValue));
    }

    /**
     * Creates a new instance in roles of this model.
     */
    async rewardTransactionPrototypeCreateCourierUserRoles(requestParameters: RewardTransactionPrototypeCreateCourierUserRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Role> {
        const response = await this.rewardTransactionPrototypeCreateCourierUserRolesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes all rewardsAccounts of this model.
     */
    async rewardTransactionPrototypeDeleteCourierRewardsAccountsRaw(requestParameters: RewardTransactionPrototypeDeleteCourierRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeDeleteCourierRewardsAccounts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardTransactions/{id}/courier/rewardsAccounts`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes all rewardsAccounts of this model.
     */
    async rewardTransactionPrototypeDeleteCourierRewardsAccounts(requestParameters: RewardTransactionPrototypeDeleteCourierRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.rewardTransactionPrototypeDeleteCourierRewardsAccountsRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes all accessTokens of this model.
     */
    async rewardTransactionPrototypeDeleteCourierUserAccessTokensRaw(requestParameters: RewardTransactionPrototypeDeleteCourierUserAccessTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeDeleteCourierUserAccessTokens().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardTransactions/{id}/courierUser/accessTokens`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes all accessTokens of this model.
     */
    async rewardTransactionPrototypeDeleteCourierUserAccessTokens(requestParameters: RewardTransactionPrototypeDeleteCourierUserAccessTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.rewardTransactionPrototypeDeleteCourierUserAccessTokensRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes all courierPackages of this model.
     */
    async rewardTransactionPrototypeDeleteCourierUserCourierPackagesRaw(requestParameters: RewardTransactionPrototypeDeleteCourierUserCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeDeleteCourierUserCourierPackages().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardTransactions/{id}/courierUser/courierPackages`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes all courierPackages of this model.
     */
    async rewardTransactionPrototypeDeleteCourierUserCourierPackages(requestParameters: RewardTransactionPrototypeDeleteCourierUserCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.rewardTransactionPrototypeDeleteCourierUserCourierPackagesRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes all invoices of this model.
     */
    async rewardTransactionPrototypeDeleteCourierUserInvoicesRaw(requestParameters: RewardTransactionPrototypeDeleteCourierUserInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeDeleteCourierUserInvoices().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardTransactions/{id}/courierUser/invoices`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes all invoices of this model.
     */
    async rewardTransactionPrototypeDeleteCourierUserInvoices(requestParameters: RewardTransactionPrototypeDeleteCourierUserInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.rewardTransactionPrototypeDeleteCourierUserInvoicesRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes all mailboxes of this model.
     */
    async rewardTransactionPrototypeDeleteCourierUserMailboxesRaw(requestParameters: RewardTransactionPrototypeDeleteCourierUserMailboxesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeDeleteCourierUserMailboxes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardTransactions/{id}/courierUser/mailboxes`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes all mailboxes of this model.
     */
    async rewardTransactionPrototypeDeleteCourierUserMailboxes(requestParameters: RewardTransactionPrototypeDeleteCourierUserMailboxesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.rewardTransactionPrototypeDeleteCourierUserMailboxesRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes all referrer of this model.
     */
    async rewardTransactionPrototypeDeleteCourierUserReferrerRaw(requestParameters: RewardTransactionPrototypeDeleteCourierUserReferrerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeDeleteCourierUserReferrer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardTransactions/{id}/courierUser/referrer`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes all referrer of this model.
     */
    async rewardTransactionPrototypeDeleteCourierUserReferrer(requestParameters: RewardTransactionPrototypeDeleteCourierUserReferrerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.rewardTransactionPrototypeDeleteCourierUserReferrerRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes all roleMappings of this model.
     */
    async rewardTransactionPrototypeDeleteCourierUserRoleMappingsRaw(requestParameters: RewardTransactionPrototypeDeleteCourierUserRoleMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeDeleteCourierUserRoleMappings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardTransactions/{id}/courierUser/roleMappings`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes all roleMappings of this model.
     */
    async rewardTransactionPrototypeDeleteCourierUserRoleMappings(requestParameters: RewardTransactionPrototypeDeleteCourierUserRoleMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.rewardTransactionPrototypeDeleteCourierUserRoleMappingsRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes all roles of this model.
     */
    async rewardTransactionPrototypeDeleteCourierUserRolesRaw(requestParameters: RewardTransactionPrototypeDeleteCourierUserRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeDeleteCourierUserRoles().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardTransactions/{id}/courierUser/roles`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes all roles of this model.
     */
    async rewardTransactionPrototypeDeleteCourierUserRoles(requestParameters: RewardTransactionPrototypeDeleteCourierUserRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.rewardTransactionPrototypeDeleteCourierUserRolesRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a related item by id for rewardsAccounts.
     */
    async rewardTransactionPrototypeDestroyByIdCourierRewardsAccountsRaw(requestParameters: RewardTransactionPrototypeDestroyByIdCourierRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeDestroyByIdCourierRewardsAccounts().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling rewardTransactionPrototypeDestroyByIdCourierRewardsAccounts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardTransactions/{id}/courier/rewardsAccounts/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a related item by id for rewardsAccounts.
     */
    async rewardTransactionPrototypeDestroyByIdCourierRewardsAccounts(requestParameters: RewardTransactionPrototypeDestroyByIdCourierRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.rewardTransactionPrototypeDestroyByIdCourierRewardsAccountsRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a related item by id for accessTokens.
     */
    async rewardTransactionPrototypeDestroyByIdCourierUserAccessTokensRaw(requestParameters: RewardTransactionPrototypeDestroyByIdCourierUserAccessTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeDestroyByIdCourierUserAccessTokens().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling rewardTransactionPrototypeDestroyByIdCourierUserAccessTokens().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardTransactions/{id}/courierUser/accessTokens/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a related item by id for accessTokens.
     */
    async rewardTransactionPrototypeDestroyByIdCourierUserAccessTokens(requestParameters: RewardTransactionPrototypeDestroyByIdCourierUserAccessTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.rewardTransactionPrototypeDestroyByIdCourierUserAccessTokensRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a related item by id for courierPackages.
     */
    async rewardTransactionPrototypeDestroyByIdCourierUserCourierPackagesRaw(requestParameters: RewardTransactionPrototypeDestroyByIdCourierUserCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeDestroyByIdCourierUserCourierPackages().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling rewardTransactionPrototypeDestroyByIdCourierUserCourierPackages().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardTransactions/{id}/courierUser/courierPackages/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a related item by id for courierPackages.
     */
    async rewardTransactionPrototypeDestroyByIdCourierUserCourierPackages(requestParameters: RewardTransactionPrototypeDestroyByIdCourierUserCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.rewardTransactionPrototypeDestroyByIdCourierUserCourierPackagesRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a related item by id for invoices.
     */
    async rewardTransactionPrototypeDestroyByIdCourierUserInvoicesRaw(requestParameters: RewardTransactionPrototypeDestroyByIdCourierUserInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeDestroyByIdCourierUserInvoices().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling rewardTransactionPrototypeDestroyByIdCourierUserInvoices().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardTransactions/{id}/courierUser/invoices/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a related item by id for invoices.
     */
    async rewardTransactionPrototypeDestroyByIdCourierUserInvoices(requestParameters: RewardTransactionPrototypeDestroyByIdCourierUserInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.rewardTransactionPrototypeDestroyByIdCourierUserInvoicesRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a related item by id for mailboxes.
     */
    async rewardTransactionPrototypeDestroyByIdCourierUserMailboxesRaw(requestParameters: RewardTransactionPrototypeDestroyByIdCourierUserMailboxesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeDestroyByIdCourierUserMailboxes().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling rewardTransactionPrototypeDestroyByIdCourierUserMailboxes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardTransactions/{id}/courierUser/mailboxes/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a related item by id for mailboxes.
     */
    async rewardTransactionPrototypeDestroyByIdCourierUserMailboxes(requestParameters: RewardTransactionPrototypeDestroyByIdCourierUserMailboxesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.rewardTransactionPrototypeDestroyByIdCourierUserMailboxesRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a related item by id for referrer.
     */
    async rewardTransactionPrototypeDestroyByIdCourierUserReferrerRaw(requestParameters: RewardTransactionPrototypeDestroyByIdCourierUserReferrerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeDestroyByIdCourierUserReferrer().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling rewardTransactionPrototypeDestroyByIdCourierUserReferrer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardTransactions/{id}/courierUser/referrer/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a related item by id for referrer.
     */
    async rewardTransactionPrototypeDestroyByIdCourierUserReferrer(requestParameters: RewardTransactionPrototypeDestroyByIdCourierUserReferrerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.rewardTransactionPrototypeDestroyByIdCourierUserReferrerRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a related item by id for roleMappings.
     */
    async rewardTransactionPrototypeDestroyByIdCourierUserRoleMappingsRaw(requestParameters: RewardTransactionPrototypeDestroyByIdCourierUserRoleMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeDestroyByIdCourierUserRoleMappings().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling rewardTransactionPrototypeDestroyByIdCourierUserRoleMappings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardTransactions/{id}/courierUser/roleMappings/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a related item by id for roleMappings.
     */
    async rewardTransactionPrototypeDestroyByIdCourierUserRoleMappings(requestParameters: RewardTransactionPrototypeDestroyByIdCourierUserRoleMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.rewardTransactionPrototypeDestroyByIdCourierUserRoleMappingsRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a related item by id for roles.
     */
    async rewardTransactionPrototypeDestroyByIdCourierUserRolesRaw(requestParameters: RewardTransactionPrototypeDestroyByIdCourierUserRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeDestroyByIdCourierUserRoles().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling rewardTransactionPrototypeDestroyByIdCourierUserRoles().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardTransactions/{id}/courierUser/roles/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a related item by id for roles.
     */
    async rewardTransactionPrototypeDestroyByIdCourierUserRoles(requestParameters: RewardTransactionPrototypeDestroyByIdCourierUserRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.rewardTransactionPrototypeDestroyByIdCourierUserRolesRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes courierSetting of this model.
     */
    async rewardTransactionPrototypeDestroyCourierCourierSettingRaw(requestParameters: RewardTransactionPrototypeDestroyCourierCourierSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeDestroyCourierCourierSetting().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardTransactions/{id}/courier/courierSetting`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes courierSetting of this model.
     */
    async rewardTransactionPrototypeDestroyCourierCourierSetting(requestParameters: RewardTransactionPrototypeDestroyCourierCourierSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.rewardTransactionPrototypeDestroyCourierCourierSettingRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes mailOption of this model.
     */
    async rewardTransactionPrototypeDestroyCourierMailOptionRaw(requestParameters: RewardTransactionPrototypeDestroyCourierMailOptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeDestroyCourierMailOption().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardTransactions/{id}/courier/mailOption`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes mailOption of this model.
     */
    async rewardTransactionPrototypeDestroyCourierMailOption(requestParameters: RewardTransactionPrototypeDestroyCourierMailOptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.rewardTransactionPrototypeDestroyCourierMailOptionRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes invoice of this model.
     */
    async rewardTransactionPrototypeDestroyCourierPackageInvoiceRaw(requestParameters: RewardTransactionPrototypeDestroyCourierPackageInvoiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeDestroyCourierPackageInvoice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardTransactions/{id}/courierPackage/invoice`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes invoice of this model.
     */
    async rewardTransactionPrototypeDestroyCourierPackageInvoice(requestParameters: RewardTransactionPrototypeDestroyCourierPackageInvoiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.rewardTransactionPrototypeDestroyCourierPackageInvoiceRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes rewardsAccount of this model.
     */
    async rewardTransactionPrototypeDestroyCourierUserRewardsAccountRaw(requestParameters: RewardTransactionPrototypeDestroyCourierUserRewardsAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeDestroyCourierUserRewardsAccount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardTransactions/{id}/courierUser/rewardsAccount`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes rewardsAccount of this model.
     */
    async rewardTransactionPrototypeDestroyCourierUserRewardsAccount(requestParameters: RewardTransactionPrototypeDestroyCourierUserRewardsAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.rewardTransactionPrototypeDestroyCourierUserRewardsAccountRaw(requestParameters, initOverrides);
    }

    /**
     * Check the existence of roles relation to an item by id.
     */
    async rewardTransactionPrototypeExistsCourierUserRolesRaw(requestParameters: RewardTransactionPrototypeExistsCourierUserRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeExistsCourierUserRoles().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling rewardTransactionPrototypeExistsCourierUserRoles().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardTransactions/{id}/courierUser/roles/rel/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'HEAD',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Check the existence of roles relation to an item by id.
     */
    async rewardTransactionPrototypeExistsCourierUserRoles(requestParameters: RewardTransactionPrototypeExistsCourierUserRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.rewardTransactionPrototypeExistsCourierUserRolesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find a related item by id for rewardsAccounts.
     */
    async rewardTransactionPrototypeFindByIdCourierRewardsAccountsRaw(requestParameters: RewardTransactionPrototypeFindByIdCourierRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RewardsAccount>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeFindByIdCourierRewardsAccounts().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling rewardTransactionPrototypeFindByIdCourierRewardsAccounts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardTransactions/{id}/courier/rewardsAccounts/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RewardsAccountFromJSON(jsonValue));
    }

    /**
     * Find a related item by id for rewardsAccounts.
     */
    async rewardTransactionPrototypeFindByIdCourierRewardsAccounts(requestParameters: RewardTransactionPrototypeFindByIdCourierRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RewardsAccount> {
        const response = await this.rewardTransactionPrototypeFindByIdCourierRewardsAccountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find a related item by id for accessTokens.
     */
    async rewardTransactionPrototypeFindByIdCourierUserAccessTokensRaw(requestParameters: RewardTransactionPrototypeFindByIdCourierUserAccessTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AccessToken>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeFindByIdCourierUserAccessTokens().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling rewardTransactionPrototypeFindByIdCourierUserAccessTokens().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardTransactions/{id}/courierUser/accessTokens/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AccessTokenFromJSON(jsonValue));
    }

    /**
     * Find a related item by id for accessTokens.
     */
    async rewardTransactionPrototypeFindByIdCourierUserAccessTokens(requestParameters: RewardTransactionPrototypeFindByIdCourierUserAccessTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AccessToken> {
        const response = await this.rewardTransactionPrototypeFindByIdCourierUserAccessTokensRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find a related item by id for courierPackages.
     */
    async rewardTransactionPrototypeFindByIdCourierUserCourierPackagesRaw(requestParameters: RewardTransactionPrototypeFindByIdCourierUserCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierPackage>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeFindByIdCourierUserCourierPackages().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling rewardTransactionPrototypeFindByIdCourierUserCourierPackages().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardTransactions/{id}/courierUser/courierPackages/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierPackageFromJSON(jsonValue));
    }

    /**
     * Find a related item by id for courierPackages.
     */
    async rewardTransactionPrototypeFindByIdCourierUserCourierPackages(requestParameters: RewardTransactionPrototypeFindByIdCourierUserCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierPackage> {
        const response = await this.rewardTransactionPrototypeFindByIdCourierUserCourierPackagesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find a related item by id for invoices.
     */
    async rewardTransactionPrototypeFindByIdCourierUserInvoicesRaw(requestParameters: RewardTransactionPrototypeFindByIdCourierUserInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Invoice>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeFindByIdCourierUserInvoices().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling rewardTransactionPrototypeFindByIdCourierUserInvoices().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardTransactions/{id}/courierUser/invoices/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvoiceFromJSON(jsonValue));
    }

    /**
     * Find a related item by id for invoices.
     */
    async rewardTransactionPrototypeFindByIdCourierUserInvoices(requestParameters: RewardTransactionPrototypeFindByIdCourierUserInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Invoice> {
        const response = await this.rewardTransactionPrototypeFindByIdCourierUserInvoicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find a related item by id for mailboxes.
     */
    async rewardTransactionPrototypeFindByIdCourierUserMailboxesRaw(requestParameters: RewardTransactionPrototypeFindByIdCourierUserMailboxesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Mailbox>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeFindByIdCourierUserMailboxes().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling rewardTransactionPrototypeFindByIdCourierUserMailboxes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardTransactions/{id}/courierUser/mailboxes/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MailboxFromJSON(jsonValue));
    }

    /**
     * Find a related item by id for mailboxes.
     */
    async rewardTransactionPrototypeFindByIdCourierUserMailboxes(requestParameters: RewardTransactionPrototypeFindByIdCourierUserMailboxesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Mailbox> {
        const response = await this.rewardTransactionPrototypeFindByIdCourierUserMailboxesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find a related item by id for referrer.
     */
    async rewardTransactionPrototypeFindByIdCourierUserReferrerRaw(requestParameters: RewardTransactionPrototypeFindByIdCourierUserReferrerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierUser>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeFindByIdCourierUserReferrer().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling rewardTransactionPrototypeFindByIdCourierUserReferrer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardTransactions/{id}/courierUser/referrer/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierUserFromJSON(jsonValue));
    }

    /**
     * Find a related item by id for referrer.
     */
    async rewardTransactionPrototypeFindByIdCourierUserReferrer(requestParameters: RewardTransactionPrototypeFindByIdCourierUserReferrerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierUser> {
        const response = await this.rewardTransactionPrototypeFindByIdCourierUserReferrerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find a related item by id for roleMappings.
     */
    async rewardTransactionPrototypeFindByIdCourierUserRoleMappingsRaw(requestParameters: RewardTransactionPrototypeFindByIdCourierUserRoleMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMapping>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeFindByIdCourierUserRoleMappings().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling rewardTransactionPrototypeFindByIdCourierUserRoleMappings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardTransactions/{id}/courierUser/roleMappings/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingFromJSON(jsonValue));
    }

    /**
     * Find a related item by id for roleMappings.
     */
    async rewardTransactionPrototypeFindByIdCourierUserRoleMappings(requestParameters: RewardTransactionPrototypeFindByIdCourierUserRoleMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMapping> {
        const response = await this.rewardTransactionPrototypeFindByIdCourierUserRoleMappingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find a related item by id for roles.
     */
    async rewardTransactionPrototypeFindByIdCourierUserRolesRaw(requestParameters: RewardTransactionPrototypeFindByIdCourierUserRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Role>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeFindByIdCourierUserRoles().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling rewardTransactionPrototypeFindByIdCourierUserRoles().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardTransactions/{id}/courierUser/roles/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleFromJSON(jsonValue));
    }

    /**
     * Find a related item by id for roles.
     */
    async rewardTransactionPrototypeFindByIdCourierUserRoles(requestParameters: RewardTransactionPrototypeFindByIdCourierUserRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Role> {
        const response = await this.rewardTransactionPrototypeFindByIdCourierUserRolesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches belongsTo relation courier.
     */
    async rewardTransactionPrototypeGetCourierRaw(requestParameters: RewardTransactionPrototypeGetCourierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Courier>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeGetCourier().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardTransactions/{id}/courier`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierFromJSON(jsonValue));
    }

    /**
     * Fetches belongsTo relation courier.
     */
    async rewardTransactionPrototypeGetCourier(requestParameters: RewardTransactionPrototypeGetCourierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Courier> {
        const response = await this.rewardTransactionPrototypeGetCourierRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches hasOne relation courierSetting.
     */
    async rewardTransactionPrototypeGetCourierCourierSettingRaw(requestParameters: RewardTransactionPrototypeGetCourierCourierSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierSettings>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeGetCourierCourierSetting().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardTransactions/{id}/courier/courierSetting`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierSettingsFromJSON(jsonValue));
    }

    /**
     * Fetches hasOne relation courierSetting.
     */
    async rewardTransactionPrototypeGetCourierCourierSetting(requestParameters: RewardTransactionPrototypeGetCourierCourierSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierSettings> {
        const response = await this.rewardTransactionPrototypeGetCourierCourierSettingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches hasOne relation mailOption.
     */
    async rewardTransactionPrototypeGetCourierMailOptionRaw(requestParameters: RewardTransactionPrototypeGetCourierMailOptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MailOption>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeGetCourierMailOption().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardTransactions/{id}/courier/mailOption`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MailOptionFromJSON(jsonValue));
    }

    /**
     * Fetches hasOne relation mailOption.
     */
    async rewardTransactionPrototypeGetCourierMailOption(requestParameters: RewardTransactionPrototypeGetCourierMailOptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MailOption> {
        const response = await this.rewardTransactionPrototypeGetCourierMailOptionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches belongsTo relation courierPackage.
     */
    async rewardTransactionPrototypeGetCourierPackageRaw(requestParameters: RewardTransactionPrototypeGetCourierPackageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierPackage>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeGetCourierPackage().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardTransactions/{id}/courierPackage`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierPackageFromJSON(jsonValue));
    }

    /**
     * Fetches belongsTo relation courierPackage.
     */
    async rewardTransactionPrototypeGetCourierPackage(requestParameters: RewardTransactionPrototypeGetCourierPackageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierPackage> {
        const response = await this.rewardTransactionPrototypeGetCourierPackageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches belongsTo relation courier.
     */
    async rewardTransactionPrototypeGetCourierPackageCourierRaw(requestParameters: RewardTransactionPrototypeGetCourierPackageCourierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Courier>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeGetCourierPackageCourier().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardTransactions/{id}/courierPackage/courier`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierFromJSON(jsonValue));
    }

    /**
     * Fetches belongsTo relation courier.
     */
    async rewardTransactionPrototypeGetCourierPackageCourier(requestParameters: RewardTransactionPrototypeGetCourierPackageCourierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Courier> {
        const response = await this.rewardTransactionPrototypeGetCourierPackageCourierRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches hasOne relation invoice.
     */
    async rewardTransactionPrototypeGetCourierPackageInvoiceRaw(requestParameters: RewardTransactionPrototypeGetCourierPackageInvoiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Invoice>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeGetCourierPackageInvoice().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardTransactions/{id}/courierPackage/invoice`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvoiceFromJSON(jsonValue));
    }

    /**
     * Fetches hasOne relation invoice.
     */
    async rewardTransactionPrototypeGetCourierPackageInvoice(requestParameters: RewardTransactionPrototypeGetCourierPackageInvoiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Invoice> {
        const response = await this.rewardTransactionPrototypeGetCourierPackageInvoiceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches belongsTo relation owner.
     */
    async rewardTransactionPrototypeGetCourierPackageOwnerRaw(requestParameters: RewardTransactionPrototypeGetCourierPackageOwnerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierUser>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeGetCourierPackageOwner().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardTransactions/{id}/courierPackage/owner`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierUserFromJSON(jsonValue));
    }

    /**
     * Fetches belongsTo relation owner.
     */
    async rewardTransactionPrototypeGetCourierPackageOwner(requestParameters: RewardTransactionPrototypeGetCourierPackageOwnerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierUser> {
        const response = await this.rewardTransactionPrototypeGetCourierPackageOwnerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Queries rewardsAccounts of Courier.
     */
    async rewardTransactionPrototypeGetCourierRewardsAccountsRaw(requestParameters: RewardTransactionPrototypeGetCourierRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<RewardsAccount>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeGetCourierRewardsAccounts().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardTransactions/{id}/courier/rewardsAccounts`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(RewardsAccountFromJSON));
    }

    /**
     * Queries rewardsAccounts of Courier.
     */
    async rewardTransactionPrototypeGetCourierRewardsAccounts(requestParameters: RewardTransactionPrototypeGetCourierRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<RewardsAccount>> {
        const response = await this.rewardTransactionPrototypeGetCourierRewardsAccountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches belongsTo relation courierUser.
     */
    async rewardTransactionPrototypeGetCourierUserRaw(requestParameters: RewardTransactionPrototypeGetCourierUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierUser>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeGetCourierUser().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardTransactions/{id}/courierUser`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierUserFromJSON(jsonValue));
    }

    /**
     * Fetches belongsTo relation courierUser.
     */
    async rewardTransactionPrototypeGetCourierUser(requestParameters: RewardTransactionPrototypeGetCourierUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierUser> {
        const response = await this.rewardTransactionPrototypeGetCourierUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Queries accessTokens of CourierUser.
     */
    async rewardTransactionPrototypeGetCourierUserAccessTokensRaw(requestParameters: RewardTransactionPrototypeGetCourierUserAccessTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AccessToken>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeGetCourierUserAccessTokens().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardTransactions/{id}/courierUser/accessTokens`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AccessTokenFromJSON));
    }

    /**
     * Queries accessTokens of CourierUser.
     */
    async rewardTransactionPrototypeGetCourierUserAccessTokens(requestParameters: RewardTransactionPrototypeGetCourierUserAccessTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AccessToken>> {
        const response = await this.rewardTransactionPrototypeGetCourierUserAccessTokensRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Queries courierPackages of CourierUser.
     */
    async rewardTransactionPrototypeGetCourierUserCourierPackagesRaw(requestParameters: RewardTransactionPrototypeGetCourierUserCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CourierPackage>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeGetCourierUserCourierPackages().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardTransactions/{id}/courierUser/courierPackages`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CourierPackageFromJSON));
    }

    /**
     * Queries courierPackages of CourierUser.
     */
    async rewardTransactionPrototypeGetCourierUserCourierPackages(requestParameters: RewardTransactionPrototypeGetCourierUserCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CourierPackage>> {
        const response = await this.rewardTransactionPrototypeGetCourierUserCourierPackagesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Queries invoices of CourierUser.
     */
    async rewardTransactionPrototypeGetCourierUserInvoicesRaw(requestParameters: RewardTransactionPrototypeGetCourierUserInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Invoice>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeGetCourierUserInvoices().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardTransactions/{id}/courierUser/invoices`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InvoiceFromJSON));
    }

    /**
     * Queries invoices of CourierUser.
     */
    async rewardTransactionPrototypeGetCourierUserInvoices(requestParameters: RewardTransactionPrototypeGetCourierUserInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Invoice>> {
        const response = await this.rewardTransactionPrototypeGetCourierUserInvoicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Queries mailboxes of CourierUser.
     */
    async rewardTransactionPrototypeGetCourierUserMailboxesRaw(requestParameters: RewardTransactionPrototypeGetCourierUserMailboxesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Mailbox>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeGetCourierUserMailboxes().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardTransactions/{id}/courierUser/mailboxes`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MailboxFromJSON));
    }

    /**
     * Queries mailboxes of CourierUser.
     */
    async rewardTransactionPrototypeGetCourierUserMailboxes(requestParameters: RewardTransactionPrototypeGetCourierUserMailboxesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Mailbox>> {
        const response = await this.rewardTransactionPrototypeGetCourierUserMailboxesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Queries referrer of CourierUser.
     */
    async rewardTransactionPrototypeGetCourierUserReferrerRaw(requestParameters: RewardTransactionPrototypeGetCourierUserReferrerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CourierUser>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeGetCourierUserReferrer().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardTransactions/{id}/courierUser/referrer`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CourierUserFromJSON));
    }

    /**
     * Queries referrer of CourierUser.
     */
    async rewardTransactionPrototypeGetCourierUserReferrer(requestParameters: RewardTransactionPrototypeGetCourierUserReferrerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CourierUser>> {
        const response = await this.rewardTransactionPrototypeGetCourierUserReferrerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches hasOne relation rewardsAccount.
     */
    async rewardTransactionPrototypeGetCourierUserRewardsAccountRaw(requestParameters: RewardTransactionPrototypeGetCourierUserRewardsAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RewardsAccount>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeGetCourierUserRewardsAccount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardTransactions/{id}/courierUser/rewardsAccount`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RewardsAccountFromJSON(jsonValue));
    }

    /**
     * Fetches hasOne relation rewardsAccount.
     */
    async rewardTransactionPrototypeGetCourierUserRewardsAccount(requestParameters: RewardTransactionPrototypeGetCourierUserRewardsAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RewardsAccount> {
        const response = await this.rewardTransactionPrototypeGetCourierUserRewardsAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Queries roleMappings of CourierUser.
     */
    async rewardTransactionPrototypeGetCourierUserRoleMappingsRaw(requestParameters: RewardTransactionPrototypeGetCourierUserRoleMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<RoleMapping>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeGetCourierUserRoleMappings().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardTransactions/{id}/courierUser/roleMappings`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(RoleMappingFromJSON));
    }

    /**
     * Queries roleMappings of CourierUser.
     */
    async rewardTransactionPrototypeGetCourierUserRoleMappings(requestParameters: RewardTransactionPrototypeGetCourierUserRoleMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<RoleMapping>> {
        const response = await this.rewardTransactionPrototypeGetCourierUserRoleMappingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Queries roles of CourierUser.
     */
    async rewardTransactionPrototypeGetCourierUserRolesRaw(requestParameters: RewardTransactionPrototypeGetCourierUserRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Role>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeGetCourierUserRoles().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardTransactions/{id}/courierUser/roles`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(RoleFromJSON));
    }

    /**
     * Queries roles of CourierUser.
     */
    async rewardTransactionPrototypeGetCourierUserRoles(requestParameters: RewardTransactionPrototypeGetCourierUserRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Role>> {
        const response = await this.rewardTransactionPrototypeGetCourierUserRolesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Add a related item by id for roles.
     */
    async rewardTransactionPrototypeLinkCourierUserRolesRaw(requestParameters: RewardTransactionPrototypeLinkCourierUserRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMapping>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeLinkCourierUserRoles().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling rewardTransactionPrototypeLinkCourierUserRoles().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/RewardTransactions/{id}/courierUser/roles/rel/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: RoleMappingToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingFromJSON(jsonValue));
    }

    /**
     * Add a related item by id for roles.
     */
    async rewardTransactionPrototypeLinkCourierUserRoles(requestParameters: RewardTransactionPrototypeLinkCourierUserRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMapping> {
        const response = await this.rewardTransactionPrototypeLinkCourierUserRolesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Patch attributes for a model instance and persist it into the data source.
     */
    async rewardTransactionPrototypePatchAttributesRaw(requestParameters: RewardTransactionPrototypePatchAttributesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RewardTransaction>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypePatchAttributes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/RewardTransactions/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: RewardTransactionToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RewardTransactionFromJSON(jsonValue));
    }

    /**
     * Patch attributes for a model instance and persist it into the data source.
     */
    async rewardTransactionPrototypePatchAttributes(requestParameters: RewardTransactionPrototypePatchAttributesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RewardTransaction> {
        const response = await this.rewardTransactionPrototypePatchAttributesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Remove the roles relation to an item by id.
     */
    async rewardTransactionPrototypeUnlinkCourierUserRolesRaw(requestParameters: RewardTransactionPrototypeUnlinkCourierUserRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeUnlinkCourierUserRoles().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling rewardTransactionPrototypeUnlinkCourierUserRoles().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/RewardTransactions/{id}/courierUser/roles/rel/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Remove the roles relation to an item by id.
     */
    async rewardTransactionPrototypeUnlinkCourierUserRoles(requestParameters: RewardTransactionPrototypeUnlinkCourierUserRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.rewardTransactionPrototypeUnlinkCourierUserRolesRaw(requestParameters, initOverrides);
    }

    /**
     * Update a related item by id for rewardsAccounts.
     */
    async rewardTransactionPrototypeUpdateByIdCourierRewardsAccountsRaw(requestParameters: RewardTransactionPrototypeUpdateByIdCourierRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RewardsAccount>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeUpdateByIdCourierRewardsAccounts().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling rewardTransactionPrototypeUpdateByIdCourierRewardsAccounts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/RewardTransactions/{id}/courier/rewardsAccounts/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: RewardsAccountToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RewardsAccountFromJSON(jsonValue));
    }

    /**
     * Update a related item by id for rewardsAccounts.
     */
    async rewardTransactionPrototypeUpdateByIdCourierRewardsAccounts(requestParameters: RewardTransactionPrototypeUpdateByIdCourierRewardsAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RewardsAccount> {
        const response = await this.rewardTransactionPrototypeUpdateByIdCourierRewardsAccountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a related item by id for accessTokens.
     */
    async rewardTransactionPrototypeUpdateByIdCourierUserAccessTokensRaw(requestParameters: RewardTransactionPrototypeUpdateByIdCourierUserAccessTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AccessToken>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeUpdateByIdCourierUserAccessTokens().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling rewardTransactionPrototypeUpdateByIdCourierUserAccessTokens().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/RewardTransactions/{id}/courierUser/accessTokens/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AccessTokenToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AccessTokenFromJSON(jsonValue));
    }

    /**
     * Update a related item by id for accessTokens.
     */
    async rewardTransactionPrototypeUpdateByIdCourierUserAccessTokens(requestParameters: RewardTransactionPrototypeUpdateByIdCourierUserAccessTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AccessToken> {
        const response = await this.rewardTransactionPrototypeUpdateByIdCourierUserAccessTokensRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a related item by id for courierPackages.
     */
    async rewardTransactionPrototypeUpdateByIdCourierUserCourierPackagesRaw(requestParameters: RewardTransactionPrototypeUpdateByIdCourierUserCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierPackage>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeUpdateByIdCourierUserCourierPackages().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling rewardTransactionPrototypeUpdateByIdCourierUserCourierPackages().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/RewardTransactions/{id}/courierUser/courierPackages/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CourierPackageToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierPackageFromJSON(jsonValue));
    }

    /**
     * Update a related item by id for courierPackages.
     */
    async rewardTransactionPrototypeUpdateByIdCourierUserCourierPackages(requestParameters: RewardTransactionPrototypeUpdateByIdCourierUserCourierPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierPackage> {
        const response = await this.rewardTransactionPrototypeUpdateByIdCourierUserCourierPackagesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a related item by id for invoices.
     */
    async rewardTransactionPrototypeUpdateByIdCourierUserInvoicesRaw(requestParameters: RewardTransactionPrototypeUpdateByIdCourierUserInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Invoice>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeUpdateByIdCourierUserInvoices().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling rewardTransactionPrototypeUpdateByIdCourierUserInvoices().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/RewardTransactions/{id}/courierUser/invoices/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InvoiceToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvoiceFromJSON(jsonValue));
    }

    /**
     * Update a related item by id for invoices.
     */
    async rewardTransactionPrototypeUpdateByIdCourierUserInvoices(requestParameters: RewardTransactionPrototypeUpdateByIdCourierUserInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Invoice> {
        const response = await this.rewardTransactionPrototypeUpdateByIdCourierUserInvoicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a related item by id for mailboxes.
     */
    async rewardTransactionPrototypeUpdateByIdCourierUserMailboxesRaw(requestParameters: RewardTransactionPrototypeUpdateByIdCourierUserMailboxesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Mailbox>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeUpdateByIdCourierUserMailboxes().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling rewardTransactionPrototypeUpdateByIdCourierUserMailboxes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/RewardTransactions/{id}/courierUser/mailboxes/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: MailboxToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MailboxFromJSON(jsonValue));
    }

    /**
     * Update a related item by id for mailboxes.
     */
    async rewardTransactionPrototypeUpdateByIdCourierUserMailboxes(requestParameters: RewardTransactionPrototypeUpdateByIdCourierUserMailboxesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Mailbox> {
        const response = await this.rewardTransactionPrototypeUpdateByIdCourierUserMailboxesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a related item by id for referrer.
     */
    async rewardTransactionPrototypeUpdateByIdCourierUserReferrerRaw(requestParameters: RewardTransactionPrototypeUpdateByIdCourierUserReferrerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierUser>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeUpdateByIdCourierUserReferrer().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling rewardTransactionPrototypeUpdateByIdCourierUserReferrer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/RewardTransactions/{id}/courierUser/referrer/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CourierUserToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierUserFromJSON(jsonValue));
    }

    /**
     * Update a related item by id for referrer.
     */
    async rewardTransactionPrototypeUpdateByIdCourierUserReferrer(requestParameters: RewardTransactionPrototypeUpdateByIdCourierUserReferrerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierUser> {
        const response = await this.rewardTransactionPrototypeUpdateByIdCourierUserReferrerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a related item by id for roleMappings.
     */
    async rewardTransactionPrototypeUpdateByIdCourierUserRoleMappingsRaw(requestParameters: RewardTransactionPrototypeUpdateByIdCourierUserRoleMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMapping>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeUpdateByIdCourierUserRoleMappings().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling rewardTransactionPrototypeUpdateByIdCourierUserRoleMappings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/RewardTransactions/{id}/courierUser/roleMappings/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: RoleMappingToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingFromJSON(jsonValue));
    }

    /**
     * Update a related item by id for roleMappings.
     */
    async rewardTransactionPrototypeUpdateByIdCourierUserRoleMappings(requestParameters: RewardTransactionPrototypeUpdateByIdCourierUserRoleMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMapping> {
        const response = await this.rewardTransactionPrototypeUpdateByIdCourierUserRoleMappingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a related item by id for roles.
     */
    async rewardTransactionPrototypeUpdateByIdCourierUserRolesRaw(requestParameters: RewardTransactionPrototypeUpdateByIdCourierUserRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Role>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeUpdateByIdCourierUserRoles().'
            );
        }

        if (requestParameters['fk'] == null) {
            throw new runtime.RequiredError(
                'fk',
                'Required parameter "fk" was null or undefined when calling rewardTransactionPrototypeUpdateByIdCourierUserRoles().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/RewardTransactions/{id}/courierUser/roles/{fk}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"fk"}}`, encodeURIComponent(String(requestParameters['fk']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: RoleToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleFromJSON(jsonValue));
    }

    /**
     * Update a related item by id for roles.
     */
    async rewardTransactionPrototypeUpdateByIdCourierUserRoles(requestParameters: RewardTransactionPrototypeUpdateByIdCourierUserRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Role> {
        const response = await this.rewardTransactionPrototypeUpdateByIdCourierUserRolesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update courierSetting of this model.
     */
    async rewardTransactionPrototypeUpdateCourierCourierSettingRaw(requestParameters: RewardTransactionPrototypeUpdateCourierCourierSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierSettings>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeUpdateCourierCourierSetting().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/RewardTransactions/{id}/courier/courierSetting`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CourierSettingsToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierSettingsFromJSON(jsonValue));
    }

    /**
     * Update courierSetting of this model.
     */
    async rewardTransactionPrototypeUpdateCourierCourierSetting(requestParameters: RewardTransactionPrototypeUpdateCourierCourierSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierSettings> {
        const response = await this.rewardTransactionPrototypeUpdateCourierCourierSettingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update mailOption of this model.
     */
    async rewardTransactionPrototypeUpdateCourierMailOptionRaw(requestParameters: RewardTransactionPrototypeUpdateCourierMailOptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MailOption>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeUpdateCourierMailOption().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/RewardTransactions/{id}/courier/mailOption`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: MailOptionToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MailOptionFromJSON(jsonValue));
    }

    /**
     * Update mailOption of this model.
     */
    async rewardTransactionPrototypeUpdateCourierMailOption(requestParameters: RewardTransactionPrototypeUpdateCourierMailOptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MailOption> {
        const response = await this.rewardTransactionPrototypeUpdateCourierMailOptionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update invoice of this model.
     */
    async rewardTransactionPrototypeUpdateCourierPackageInvoiceRaw(requestParameters: RewardTransactionPrototypeUpdateCourierPackageInvoiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Invoice>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeUpdateCourierPackageInvoice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/RewardTransactions/{id}/courierPackage/invoice`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InvoiceToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvoiceFromJSON(jsonValue));
    }

    /**
     * Update invoice of this model.
     */
    async rewardTransactionPrototypeUpdateCourierPackageInvoice(requestParameters: RewardTransactionPrototypeUpdateCourierPackageInvoiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Invoice> {
        const response = await this.rewardTransactionPrototypeUpdateCourierPackageInvoiceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update rewardsAccount of this model.
     */
    async rewardTransactionPrototypeUpdateCourierUserRewardsAccountRaw(requestParameters: RewardTransactionPrototypeUpdateCourierUserRewardsAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RewardsAccount>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionPrototypeUpdateCourierUserRewardsAccount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/RewardTransactions/{id}/courierUser/rewardsAccount`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: RewardsAccountToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RewardsAccountFromJSON(jsonValue));
    }

    /**
     * Update rewardsAccount of this model.
     */
    async rewardTransactionPrototypeUpdateCourierUserRewardsAccount(requestParameters: RewardTransactionPrototypeUpdateCourierUserRewardsAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RewardsAccount> {
        const response = await this.rewardTransactionPrototypeUpdateCourierUserRewardsAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replace attributes for a model instance and persist it into the data source.
     */
    async rewardTransactionReplaceByIdPostRewardTransactionsidReplaceRaw(requestParameters: RewardTransactionReplaceByIdPostRewardTransactionsidReplaceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RewardTransaction>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionReplaceByIdPostRewardTransactionsidReplace().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/RewardTransactions/{id}/replace`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RewardTransactionToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RewardTransactionFromJSON(jsonValue));
    }

    /**
     * Replace attributes for a model instance and persist it into the data source.
     */
    async rewardTransactionReplaceByIdPostRewardTransactionsidReplace(requestParameters: RewardTransactionReplaceByIdPostRewardTransactionsidReplaceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RewardTransaction> {
        const response = await this.rewardTransactionReplaceByIdPostRewardTransactionsidReplaceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replace attributes for a model instance and persist it into the data source.
     */
    async rewardTransactionReplaceByIdPutRewardTransactionsidRaw(requestParameters: RewardTransactionReplaceByIdPutRewardTransactionsidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RewardTransaction>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rewardTransactionReplaceByIdPutRewardTransactionsid().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/RewardTransactions/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: RewardTransactionToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RewardTransactionFromJSON(jsonValue));
    }

    /**
     * Replace attributes for a model instance and persist it into the data source.
     */
    async rewardTransactionReplaceByIdPutRewardTransactionsid(requestParameters: RewardTransactionReplaceByIdPutRewardTransactionsidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RewardTransaction> {
        const response = await this.rewardTransactionReplaceByIdPutRewardTransactionsidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replace an existing model instance or insert a new one into the data source.
     */
    async rewardTransactionReplaceOrCreatePostRewardTransactionsReplaceOrCreateRaw(requestParameters: RewardTransactionReplaceOrCreatePostRewardTransactionsReplaceOrCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RewardTransaction>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/RewardTransactions/replaceOrCreate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RewardTransactionToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RewardTransactionFromJSON(jsonValue));
    }

    /**
     * Replace an existing model instance or insert a new one into the data source.
     */
    async rewardTransactionReplaceOrCreatePostRewardTransactionsReplaceOrCreate(requestParameters: RewardTransactionReplaceOrCreatePostRewardTransactionsReplaceOrCreateRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RewardTransaction> {
        const response = await this.rewardTransactionReplaceOrCreatePostRewardTransactionsReplaceOrCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replace an existing model instance or insert a new one into the data source.
     */
    async rewardTransactionReplaceOrCreatePutRewardTransactionsRaw(requestParameters: RewardTransactionReplaceOrCreatePutRewardTransactionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RewardTransaction>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/RewardTransactions`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: RewardTransactionToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RewardTransactionFromJSON(jsonValue));
    }

    /**
     * Replace an existing model instance or insert a new one into the data source.
     */
    async rewardTransactionReplaceOrCreatePutRewardTransactions(requestParameters: RewardTransactionReplaceOrCreatePutRewardTransactionsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RewardTransaction> {
        const response = await this.rewardTransactionReplaceOrCreatePutRewardTransactionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update instances of the model matched by {{where}} from the data source.
     */
    async rewardTransactionUpdateAllRaw(requestParameters: RewardTransactionUpdateAllRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingUpdateAll200Response>> {
        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/RewardTransactions/update`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RewardTransactionToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingUpdateAll200ResponseFromJSON(jsonValue));
    }

    /**
     * Update instances of the model matched by {{where}} from the data source.
     */
    async rewardTransactionUpdateAll(requestParameters: RewardTransactionUpdateAllRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingUpdateAll200Response> {
        const response = await this.rewardTransactionUpdateAllRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an existing model instance or insert a new one into the data source based on the where criteria.
     */
    async rewardTransactionUpsertWithWhereRaw(requestParameters: RewardTransactionUpsertWithWhereRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RewardTransaction>> {
        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/RewardTransactions/upsertWithWhere`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RewardTransactionToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RewardTransactionFromJSON(jsonValue));
    }

    /**
     * Update an existing model instance or insert a new one into the data source based on the where criteria.
     */
    async rewardTransactionUpsertWithWhere(requestParameters: RewardTransactionUpsertWithWhereRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RewardTransaction> {
        const response = await this.rewardTransactionUpsertWithWhereRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
